import { IconType } from "react-icons";

type Props = {
  onClick: VoidFunction;
  icon?: IconType;
  label: string;
};

const ListItemDynamic = ({ onClick, label, icon: Icon }: Props) => {
  return (
    <button
      onClick={onClick}
      className={
        "flex items-center gap-1.5 px-3.5 py-2.5 text-secondary outline-none outline-0 ring-inset hover:bg-secondary-hover focus-visible:ring-4 focus-visible:ring-focus-input"
      }
    >
      {Icon && <Icon className="size-6 stroke-[1.5px]" />}
      <span className={"text-sm font-medium"}>{label}</span>
    </button>
  );
};

export default ListItemDynamic;
